<template>
  <sui-page>
    <sui-page-header title="Grid UI"></sui-page-header>
    <sui-page-contents>      
      <sui-grid-header>
        <div class="btn_wrapR">
          <button type="button" class="comm_btn_gridTop comm_ico_excel">엑셀 다운로드</button>
          <button type="button" class="comm_btn_gridTop">관련업무</button>
          <button type="button" class="comm_btn_gridTop_Brd">저장</button>
          <button type="button" class="comm_btn_gridTop" disabled="true">세부정보</button>
          <button type="button" class="comm_btn_gridTop_Brd" disabled="true">저장</button>
        </div>
      </sui-grid-header>
      <sui-jqx-grid :columns="gridColumns0" :selectionmode="'checkbox'" :pagerheight="0" :columnsautoresize="true" :pagerrenderer="gridPageRenderer" :pageable="true" :autoheight="true" width="100%" :dataset="'dataset0'" :rowsheight="40" pagermode="simple"></sui-jqx-grid>
      <sui-grid-pager dataset="dataset0" />
      <div class="comm_title_wrap">
        <h4>셔틀형</h4>
      </div>
      <div class="comm_shut_wrap">
        <div class="inbox">
          <sui-jqx-grid :autoheight="false" :columns="gridColumns1" :columnsautoresize="true" width="100%" :dataset="'dataset1'" height="250px" :rowsheight="40" scrollbarsize="0" columnsresize="enable"></sui-jqx-grid>
        </div>
        <div class="btnbox">
          <ul>
            <li>
              <button type="button" class="comm_btn_shut_right">오른쪽보내기</button>
            </li>
            <li>
              <button type="button" class="comm_btn_shut_left">왼쪽보내기</button>
            </li>
          </ul>
        </div>
        <div class="inbox">
          <sui-jqx-grid :columns="gridColumns2" :columnsautoresize="true" :dataset="'dataset2'" width="100%" height="250px" :rowsheight="40" columnsresize="enable" scrollbarsize="0"></sui-jqx-grid>
        </div>
      </div>
      <div class="comm_title_wrap">
        <h4>트리형</h4>
      </div>
      <sui-tree v-bind="fdpTree00" mutiple :show-checkbox="showCheckbox" class="brdG01 pd20" style="height:250px; overflow-y:auto"></sui-tree>
    </sui-page-contents>
  </sui-page>
</template>
<script>
  export default {
    name: "TMP_COM_002",
    methods: {
      gridPageRenderer() {
        const pager = document.createElement('div');
        pager.setAttribute('style', 'height=0px')
        return document.createElement('div');
      },
    },
    data() {
      return {
        selected: {
          md: {
            key: '',
            label: ''
          },
          smd: {
            key: '',
            label: ''
          },
          code: {
            key: '',
            label: ''
          },
          lang: {
            key: '',
            label: ''
          },
          yn: {
            key: '',
            label: ''
          },
          custom: {
            key: '개발',
            label: ''
          },
          customlang: {
            key: '',
            label: ''
          },
        },
        customOptions: [{
            key: 'D',
            label: '개발'
          },
          {
            key: 'F',
            label: '완료'
          },
        ],
        localdata0: [
          ['', '1', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '2', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '3', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '4', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '5', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '6', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '7', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '8', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '9', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '10', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '11', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '12', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '13', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '14', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '15', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '16', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '17', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '18', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '19', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '20', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '21', '1321321313', '1321321313', '12313', '2019-01-20'],
        ],
        gridColumns0: [{
          text: '기본 텍스트',
          datafield: 'datafield1'
        }, {
          text: '텍스트필드',
          datafield: 'textfield',
          createwidget: (row, column, value, htmlElement) => {
            const componentInstance = utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
              trim: true,
            }, this.dataset0);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        }, {
          text: '셀렉트박스',
          datafield: 'datafield2',
          createwidget: (row, column, value, htmlElement) => {
            const componentInstance = utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement, {
              optionList: this.customOptions,
            }, this.dataset0);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        }, {
          text: '라디오버튼',
          datafield: 'datafield3',
          $component: this,
          createwidget: (row, column, value, htmlElement) => {
            const componentInstance = utils.getGridCellFactory().createCellRadioGroup(row, column, value, htmlElement, {
              items: [{
                key: 'Y',
                label: 'Yes'
              }, {
                key: 'N',
                label: 'No'
              }],
            }, this.dataset0);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        }, {
          text: '데이트피커',
          datafield: 'datafield4'
        }],
        fdpTree00: {
          data: [{
            text: 'G-EHS',
            opened: true,
            children: [{
                text: 'Tree01 depth_1',
                opened: true,
                children: [{
                  text: 'Tree01 depth_2',
                  opened: true,
                  children: [{
                      text: 'Tree01 depth_30',
                      opened: true,
                      children: [{
                        text: 'Tree01 depth_40'
                      }, {
                        text: 'Tree01 depth_41'
                      }]
                    },
                    {
                      text: 'Tree01 depth_31'
                    }, {
                      text: 'Tree01 depth_32'
                    }, {
                      text: 'Tree01 depth_33'
                    }, {
                      text: 'Tree01 depth_34'
                    }
                  ]
                }, {
                  text: 'Tree01 depth_2'
                }]
              }, {
                text: 'Tree02 depth_1'
              },
              {
                text: 'Tree03 depth_1'
              },
              {
                text: 'Tree04 depth_1',
                opened: true,
                children: [{
                  text: 'Tree04 depth_21'
                }, {
                  text: 'Tree04 depth_22'
                }, {
                  text: 'Tree04 depth_23'
                }]
              },
              {
                text: 'Tree05 depth_1'
              }
            ]
          }]
        },
        localdata1: [
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4']
        ],
        gridColumns1: [{
          text: '컬럼01',
          datafield: 'datafield0'
        }, {
          text: '타이틀이겁나길면어떻게들어가나봅시다',
          datafield: 'datafield1'
        }, {
          text: '이만큼쓰면넘어가려나점이생기려나',
          datafield: 'datafield2'
        }, {
          text: '일하기싫을때는 집에가자 먹고싶을땐 대지같이 먹자',
          datafield: 'datafield3'
        }],
        localdata2: [
          ['1', '로또1등 2번이나 당첨된 사람', '취미로 회사다니는 사람', '4', '5'],
          ['11', '22', '33', '44', '55'],
          ['1', '2', '3', '4', '5'],
          ['취미로 회사다니는 사람', '22', '33', '가진게돈밖에 없는 사람', '55'],
          ['1', '2', '3', '4', '5'],
          ['11', '22', '33', '44', '55'],
          ['1', '2', '3', '4', '5'],
          ['11', '22', '33', '44', '55'],
          ['1', '2', '3', '4', '5'],
          ['11', '22', '33', '44', '55'],
          ['1', '2', '3', '4', '5'],
          ['11', '22', '33', '44', '55'],
          ['1', '2', '3', '4', '5'],
          ['11', '22', '33', '44', '55'],
          ['1', '2', '3', '4', '5'],
          ['11', '22', '33', '44', '55']
        ],
        gridColumns2: [{
          text: '제목',
          datafield: 'datafield0'
        }, {
          text: '이름이길어지면 이게 맞는건가',
          datafield: 'datafield1'
        }, {
          text: '공백',
          datafield: 'datafield2'
        }, {
          text: '나도몰라',
          datafield: 'datafield3'
        }, {
          text: '오늘할일은내일로',
          datafield: 'datafield4'
        }]
      };
    },
    datasets: [{
      id: 'dataset0',
      type: 'local',
      data: 'localdata0',
      datafields: [{
        name: 'chk',
        type: 'string',
        map: '0'
      }, {
        name: 'datafield1',
        type: 'string',
        map: '1'
      }, {
        name: 'textfield',
        type: 'string',
        map: '2'
      }, {
        name: 'datafield2',
        type: 'string',
        map: '3'
      }, {
        name: 'datafield3',
        type: 'string',
        map: '4'
      }, {
        name: 'datafield4',
        type: 'string',
        map: '5'
      }]
    }, {
      id: 'dataset1',
      type: 'local',
      data: 'localdata1',
      datafields: [{
        name: 'datafield0',
        type: 'string',
        map: '0'
      }, {
        name: 'datafield1',
        type: 'string',
        map: '1'
      }, {
        name: 'datafield2',
        type: 'string',
        map: '2'
      }, {
        name: 'datafield3',
        type: 'string',
        map: '3'
      }]
    }, {
      id: 'dataset2',
      type: 'local',
      data: 'localdata2',
      datafields: [{
        name: 'datafield0',
        type: 'string',
        map: '0'
      }, {
        name: 'datafield1',
        type: 'string',
        map: '1'
      }, {
        name: 'datafield2',
        type: 'string',
        map: '2'
      }, {
        name: 'datafield3',
        type: 'string',
        map: '3'
      }, {
        name: 'datafield4',
        type: 'string',
        map: '4'
      }]
    }]
  };
</script>
<style scoped>
</style>
